import $ from "dabbyjs/src/core/dabby/dabby.js";
import "dabbyjs/src/attributes/data/data.js";
import "./swgfl/javascript/accessibility.js";
import cookies from "./swgfl/cookies/javascript/cookies.js";
import security from "./swgfl/security/javascript/all.js";
import cms from "./swgfl/cms/javascript/cms.js";
import forms from "./swgfl/forms/javascript/forms.js";
import help from "./swgfl/help/javascript/help.js";
import selfreviewpro from "./selfreviewpro/javascript/selfreviewpro.js";
import faqs from "./swgfl/faqs/javascript/faqs.js";
import gtm from "./swgfl/javascript/google-tag-manager.js";
import map from "./swgfl/javascript/map.js";
import chromeFixPageBreaks from "./swgfl/pdf/javascript/chrome-fix-page-breaks.js";

$(() => {
	cookies($(".cookies"));
	security();
	cms($("#form-cms"));
	forms();
	help($(".help"));
	selfreviewpro();
	faqs($(".faqs"));
	gtm($("html").data("gtm"));

	// hook up some maps
	map($("[data-map]"));
	chromeFixPageBreaks($("body.pdf"), 1297);
});
